"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewOrganisationInvite extends new_item_1.default {
    constructor(newOrganisationInvite) {
        super();
        this.orgPermission = newOrganisationInvite.orgPermission;
        this.emailAddress = newOrganisationInvite.emailAddress;
        this.inviteSent = newOrganisationInvite.inviteSent;
        this.linkOpened = newOrganisationInvite.linkOpened;
        this.orgName = newOrganisationInvite.orgName;
        this.orgId = newOrganisationInvite.orgId;
        this.orgOverridePerms = newOrganisationInvite.orgOverridePerms;
        this.sitesLimitedTo = newOrganisationInvite.sitesLimitedTo;
    }
}
exports.default = NewOrganisationInvite;
//# sourceMappingURL=new-organisationInvite.js.map